module.exports = __webpack_public_path__ + "img/voucher-modal_img.66d46ad.svg";